const KEY = 'nextUrl';
const MAGIC_LINK_PATH_PATTERN = /^\/magic-link(\/|$)/i;

const isPathOnThisSite = (value: string) => {
  if (!value.startsWith('/')) {
    return false;
  }

  try {
    // Parsed like the browser does it, so "//host", "/\host" and a tab before the second
    // slash all count as another site.
    return new URL(value, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
};

export const storeNextUrl = ({ pathname, search }: { pathname: string; search: string }) => {
  const next = new URLSearchParams(search).get('next');

  // Not from a sign-in link: whoever sent the link would choose where the Host lands.
  if (next && !MAGIC_LINK_PATH_PATTERN.test(pathname)) {
    localStorage.setItem(KEY, next);
  }
};

export const takeNextUrl = () => {
  const next = localStorage.getItem(KEY);
  localStorage.removeItem(KEY);

  return next && isPathOnThisSite(next) ? next : null;
};
